import React from "react";
import "../styles/WhoAreWe.css";
import serviceImage3 from "../assets/system-requirements.jpg";
import Header from "./Header";
import Footer from "./Footer";
import '../styles/ContactUs.css';

const SystemRequirements = () => {

   const OpensupportInNewTab = () =>
  {
    window.open('../Support')
  }

  return (
    <>
      <Header />

      <div className="systemRequirementsPage">
        <section className="fleet-efficiency" id="SystemRequirements">
          <div className="container">
            <div className="content">
              <h1>System Requirements</h1>
              <hr className="underline" />

              <div className="text-image-row">
                <div className="text-container">
                  <h2>Minimum Requirements:</h2>
                  <p>
                    {/* GeoParking supports Windows 11+, macOS Sequoia+, and modern browsers like Chrome, Safari, or Edge.
                    Use a device with at least 8GB RAM and a stable internet connection for the best experience. */}
                    GeoParking supports devices running Windows 11+, macOS Sequoia+, and modern browsers such as Chrome, Safari, and Edge. For best performance, use a device with at least 8GB RAM and a stable internet connection.
                  </p>

                  <h2>System Requirements for Lot Owners:</h2>
                  <p>
                    {/* Access the GeoParking Dashboard using a desktop or tablet with 8GB RAM, a stable internet connection, and an updated modern browser (Chrome, Safari, or Edge). */}
                    To access and manage your GeoParking dashboard, please use a device with at least 8GB of RAM, a stable internet connection, and a modern web browser (Chrome, Safari, or Edge). The platform is compatible with desktop and tablet devices running Windows 11+, macOS Sequoia+ .
                  </p>
                </div>

                <div className="image-container">
                  <img src={serviceImage3} alt="System requirements" />
                </div>
              </div>
            <button  className="Support-button"  onClick={OpensupportInNewTab}>Contact Support</button>

            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default SystemRequirements;
